import React from 'react'

import { Link } from 'react-router-dom'
import { individualData as ICData } from '../../../data/ComercialesIndividual'
import { familyData as FData} from '../../../data/ParticularesFamily.data'
import { individualData as IData } from '../../../data/ParticularesIndividual.data'

import Home from './../../../UI/canvas/Sidebar/Home_white.svg'
import Hyundai from './../../../UI/canvas/Sidebar/Logo_Proyecto.svg'
import Logo_Umbra from './../../../UI/canvas/Sidebar/by_umbra.svg'

interface Props{
    handleOpenSidebar: any
    openedSidebar: boolean,
    isComerciales: boolean,
    handleSelectFamily: any,
    handleSelectIndividual: any,
    selectedFamily: string,
    selectedFamilyIndex: number,
}

interface State{
    IndividualParticularesData: any,
    FamilyParticularesData: any,
    FamilyComercialesData: any
}

class Sidebar extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {
            IndividualParticularesData: IData()[0],
            FamilyParticularesData: FData()[0]["FAMILIAS"],
            FamilyComercialesData: ICData()[0]["FAMILIAS"]
        }
    }

    handleCreateMenuStructure = () => {
        return(
            !this.props.isComerciales ? 
            this.state.FamilyParticularesData.map((familySelector: any, index:number) => 
                <div className='sidebar-general-container'>
                    <div className='family-btn-container' onClick={() => {this.props.selectedFamily !== familySelector.Nombre ? this.props.handleSelectFamily(familySelector.Nombre, index):this.props.handleSelectFamily("", -1)}}>
                        <div>{familySelector.Nombre}</div>
                        <hr/>
                    </div>
                    {
                        this.props.selectedFamily === familySelector.Nombre ?
                        this.state.IndividualParticularesData[this.props.selectedFamily].map((individualSelector: any, indexIndividual: number ) => 
                        <div className='individual-btn-container' onClick={() => {this.props.handleSelectIndividual(individualSelector.Nombre, indexIndividual)}}>
                            <div>{individualSelector.Nombre}</div>
                            <hr/>
                        </div>
                        ) :null
                    }
                </div>
            ):
            this.state.FamilyComercialesData.map((familySelector: any, index:number) => 
                <div className='sidebar-general-container'>
                    <div className='family-btn-container' onClick={() => {this.props.selectedFamily !== familySelector.Nombre ? this.props.handleSelectIndividual(familySelector.Nombre, index):this.props.handleSelectIndividual("", -1)}}>
                        <div>{familySelector.Nombre}</div>
                        <hr/>
                    </div>
                </div>
            )
        )
        
    }

    render(): React.ReactNode {
        return(
            <div className={this.props.openedSidebar ? "sidebar-opened":"sidebar-closed"}>
                <div className={this.props.openedSidebar ? 'sidebar-opened-menu-container':'sidebar-menu-container'} onClick={() => {this.props.handleOpenSidebar()}}>
                    <div 
                        className={this.props.openedSidebar ? 'sidebar-btn-opened':'sidebar-btn'} 
                        style = {{pointerEvents: "all"}}
                    >
                        <div className={this.props.openedSidebar ? 'top-bar-opened':'top-bar-collapsed'}/>
                        <div className={this.props.openedSidebar ? 'middle-bar-opened':'middle-bar-collapsed'}/>
                        <div className={this.props.openedSidebar ? 'bottom-bar-opened':'bottom-bar-collapsed'}/>
                    </div>
                    <div className='sidebar-text'>
                        MENÚ
                    </div>
                </div>
                {
                    this.props.openedSidebar ?
                    <div className='sidebar-content'>
                        <div className='sidebar-link-btns'>
                            <div className='sidebar-home-btn'>
                                <Link to={"/"}>
                                    <img src={Home}/>
                                </Link>
                            </div>
                            <div className='vertical-hr'></div>
                            <div className='hyundai-btn'>
                                <a href='https://www.hyundaicolombia.co/' target={"_blank"}>
                                    <img src={Hyundai}/>
                                </a>
                            </div>
                        </div>
                        <div className='sidebar-text-container'>
                            <div className='sidebar-first-text'>Estás viendo</div>
                            <div className='sidebar-second-text'>Showroom {this.props.isComerciales ? "Comerciales":"Particulares"}</div>
                        </div>
                        <div className='sidebar-car-btns-container'>
                            {
                                this.handleCreateMenuStructure()
                            }
                        </div>
                        <div className='sidebar-selector-container'>
                            <div className='showroom-selector-text'>¿Buscas algo diferente?</div>
                            <div className='showroom-selector-btn'>
                                <Link to={this.props.isComerciales ? "/vehiculos-particulares":"/vehiculos-comerciales"}>
                                    <div>Ver Showroom {this.props.isComerciales ? " particulares":" comerciales"}</div>
                                </Link>
                            </div>
                        </div>
                        <div className='logo-umbra-container'>
                            <a href='https://www.umbraint.com/' target={"_blank"}>
                                <img src={Logo_Umbra}/>
                            </a>
                        </div>
                    </div>: null
                }
            </div>
        )
    }
}

export default Sidebar